export type GridConfigValue =
	| 'default'
	| 'mirrored'
	| 'split'
	| 'splitMirrored'
	| 'defaultTablet';

export const GRID_CONFIG_VALUES: GridConfigValue[] = [
	'default',
	'mirrored',
	'split',
	'splitMirrored',
	'defaultTablet',
];

export const TRADE_PAGE_GRID_CONFIGURATIONS: {
	value: GridConfigValue;
	label: string;
}[] = [
	{ value: 'default', label: 'Default' },
	{ value: 'mirrored', label: 'Mirrored' },
	{ value: 'split', label: 'Split' },
	{ value: 'splitMirrored', label: 'Split (Mirrored)' },
];

export const TRADE_PAGE_GRID_CONFIGURATIONS_NO_ORDERBOOK: {
	value: GridConfigValue;
	label: string;
}[] = [
	{ value: 'default', label: 'Default' },
	{ value: 'mirrored', label: 'Mirrored' },
];

export const TRADE_AREAS = {
	MarketBar: 'market-bar',
	MarketSelector: 'market-selector',
	Chart: 'chart',
	Orderbook: 'orderbook',
	TradeForm: 'trade-form',
	Table: 'table',
} as const;
